<template>
  <d-modal
    size="lg"
    class="big-popup"
    @close="closePopup">
    <d-modal-header>
      <d-modal-title>
        <template v-if="popupFilter !== 'OFFERS_TO_CHECK'">{{ $t('order.ordersList') }}</template>
        {{ filterTitle }} {{ statusTitle }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <orders
        :popupFilter="popupFilter"
        :popupStatus="popupStatus"
        :popupShowAll="popupShowAll"
        :popupShowAllUI="true"
        :inPopup="true"
        :showWorkers="popupFilter === 'OFFERS_TO_CHECK'"
        :dashboardParam="dashboardParam" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import Orders from './../../views/Orders';

export default {
  name: 'orders-popup',
  props: [
    'popupFilter',
    'popupStatus',
    'popupShowAll',
    'dashboardParam'
  ],
  components: {
    'orders': Orders
  },
  computed: {
    filterTitle () {
      switch (this.popupFilter) {
        case 'OBTAINING': return this.$t('order.awaitingSample');
        case 'ACCEPTING': return this.$t('order.awaitingSampleAcceptance');
        case 'ENDING_PRODUCTION': return this.$t('order.awaitingProductionComplete');
        case 'DEADLINE': return this.$t('order.withDeadlineApproaching');
        case 'WITHOUT_SETTLEMENT': return this.$t('order.awaitingInvoice');
        case 'OFFERS_TO_CHECK': return this.$t('order.offersToCheck');
        default: return '';
      }
    },
    statusTitle () {
      switch (this.popupStatus) {
        case 'PREPARATION_FOR_SHIPPING': return this.$t('order.dashReadyForShipping');
        case 'WAITING_FOR_SHIPPING': return this.$t('order.dashOrderAwaitingShipping');
        default: return '';
      }
    }
  },
  methods: {
    closePopup () {
      this.$bus.$emit('dashboard-orders-popup-close');
    }
  }
};
</script>
